
(function ($) {
  $(document).ready(function () {
    $('.js-select2').select2({
      placeholder: "Select option...",
      allowClear: true,
      width: '100%'
    });
  });
})(jQuery);
